
import { mapGetters } from 'vuex'
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'

const PAYMENT_INTERVALS = [
  { value: 0, key: 'daily' },
  { value: 1, key: 'weekly' },
  { value: 2, key: 'monthly' },
  { value: 3, key: 'yearly' },
]

const CURRENCY_MAP = {
  0: 'TRY',
  1: 'USD',
  2: 'EUR',
  3: 'GBP',
}

const PAYMENT_TYPE_KEYS = {
  RECURRING: 'pricing.paymentTypes.recurring',
  ONE_TIME: 'pricing.paymentTypes.oneTime',
  PREPAID: 'pricing.paymentTypes.prepaid',
}

export default {
  name: 'SubscriptionGetPackages',
  components: {
    InnerLoading,
  },
  data() {
    return {
      packages: [],
      groupedPackages: {},
      activeInterval: null,
      isLoading: true,
      errorMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      getUserSubscriptions: 'user/getUserSubscriptions',
    }),
    hasPackages() {
      return this.packages.length > 0
    },
    availableIntervals() {
      return PAYMENT_INTERVALS.filter(
        (interval) => (this.groupedPackages[interval.value] || []).length
      ).map((interval) => ({
        ...interval,
        title: this.$custom$t(`pricing.intervalTabs.${interval.key}.title`),
        subtitle: this.$custom$t(`pricing.intervalTabs.${interval.key}.subtitle`),
      }))
    },
    activePackages() {
      if (!this.activeInterval && this.availableIntervals.length) {
        return this.groupedPackages[this.availableIntervals[0].value] || []
      }

      return this.groupedPackages[this.activeInterval] || []
    },
    userSubscriptionPackageIds() {
      const userSubs = Array.isArray(this.getUserSubscriptions)
        ? this.getUserSubscriptions
        : this.getUserSubscriptions?.subscriptions || []

      return userSubs
        .map((sub) => sub.subscriptionPackageId)
        .filter((id) => id != null && id !== undefined)
    },
  },
  watch: {
    availableIntervals: {
      immediate: true,
      handler(intervals) {
        if (!intervals.length) {
          this.activeInterval = null
          return
        }

        if (!intervals.find((interval) => interval.value === this.activeInterval)) {
          this.activeInterval = intervals[0].value
        }
      },
    },
  },
  mounted() {
    this.fetchPackages()
  },
  methods: {
    async fetchPackages() {
      this.isLoading = true
      this.errorMessage = ''

      try {
        const response = await this.$api.get('Subscription/GetPackages')
        const payload = response?.data ?? response
        const items =
          (Array.isArray(payload) && payload) ||
          (Array.isArray(payload?.data) && payload.data) ||
          (Array.isArray(payload?.items) && payload.items) ||
          (Array.isArray(payload?.data?.items) && payload.data.items) ||
          []

        this.packages = items
        this.groupedPackages = this.groupPackages(items)
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          this.$custom$t('pricing.error')
      } finally {
        this.isLoading = false
      }
    },
    groupPackages(items) {
      return items.reduce((acc, item) => {
        const key = Number(item.paymentInterval)
        if (Number.isNaN(key)) {
          return acc
        }

        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(item)
        return acc
      }, {})
    },
    setActiveInterval(intervalValue) {
      this.activeInterval = intervalValue
    },
    getIntervalMeta(value) {
      return PAYMENT_INTERVALS.find((interval) => interval.value === Number(value))
    },
    intervalLabel(value, variant = 'title') {
      const interval = this.getIntervalMeta(value)
      if (!interval) {
        return ''
      }

      if (variant === 'title') {
        return this.$custom$t(`pricing.intervalTabs.${interval.key}.title`)
      }

      return this.$custom$t(`pricing.intervalLabels.${interval.key}.${variant}`)
    },
    formatPrice(amount, currencyCode) {
      const currency =
        typeof currencyCode === 'string'
          ? currencyCode
          : CURRENCY_MAP[currencyCode] || 'TRY'

      try {
        return new Intl.NumberFormat(this.$i18n.locale || 'tr-TR', {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format(Number(amount) || 0)
      } catch (error) {
        return `${Number(amount) || 0} ${currency}`
      }
    },
    billingText(plan) {
      if (!plan.paymentInterval && !plan.paymentIntervalCount) {
        return ''
      }

      const interval = this.getIntervalMeta(plan.paymentInterval)
      if (!interval) {
        return ''
      }

      const intervalLabel = this.$custom$t(
        `pricing.intervalLabels.${interval.key}.single`
      ).toLowerCase()

      return this.$custom$t('pricing.card.billed', {
        count: plan.paymentIntervalCount || 1,
        interval: intervalLabel,
      })
    },
    paymentTypeLabel(type) {
      const key = PAYMENT_TYPE_KEYS[type] || PAYMENT_TYPE_KEYS.RECURRING
      return this.$custom$t(key)
    },
    trialLabel(plan) {
      if (!plan.trialPeriodDays) {
        return ''
      }
      return this.$custom$t('pricing.card.trial', {
        days: plan.trialPeriodDays,
      })
    },
    handlePlanSelect(plan) {
      this.$emit('plan-select', plan)
    },
    isPlanOwned(planId) {
      console.log(this.userSubscriptionPackageIds, "userSubscriptionPackageIds")
      console.log(planId, "planId")
      return this.userSubscriptionPackageIds.includes(Number(planId))
    },
  },
}
